import assign from "lodash.assign";
import omit from "lodash.omit";
import values from "lodash.values";

interface InternalError {
    type: string;
    message: string;
    persist?: boolean;
}

interface InternalErrors {
    [s: string]: InternalError;
}

function setErrorInErrors(errors: InternalErrors, error: InternalError): InternalErrors {
    return assign({}, errors, { [error.type]: error });
}

function clearErrorFromErrors(errors: InternalErrors, errorType?: string): InternalErrors {
    return errorType ? omit(errors, errorType) : {};
}

function clearErrorsFromErrors(errors: InternalErrors, errorTypes?: string[]): InternalErrors {
    if (errorTypes) {
        return omit(errors, errorTypes);
    }

    return errors;
}

function keepPersistedErrors(errors: InternalErrors): InternalErrors {
    const persistedErrorsArray = values(errors).filter((error) => error.persist);

    return persistedErrorsArray.reduce((persistedErrors: InternalErrors, error: InternalError): InternalErrors => {
        persistedErrors[error.type] = error;

        return persistedErrors;
    }, {});
}

export {
    setErrorInErrors,
    clearErrorsFromErrors,
    clearErrorFromErrors,
    keepPersistedErrors
};
